<template>
  <div>
    <div class="max-w-5xl mx-auto space-y-16">
      <div>
        <BaseButton primary @click="openCreateModal"> Προσθήκη Υπηρεσίας </BaseButton>
      </div>

      <BaseGrid :columns="1">
        <GridCard
          v-for="productService in productServices"
          :key="productService.uuid"
          :entity="productService"
          @product-service-edit="openUpdateModal"
          @product-service-delete="confirmProductServiceDeleteAction"
          @product-service-upgrade-create="openCreateUpgradeModal"
          @product-service-upgrade-edit="openUpdateUpgradeModal"
          @product-service-upgrade-delete="confirmProductServiceUpgradeDeleteAction"
        />
      </BaseGrid>
    </div>

    <portal v-if="displayCreateModal" to="app-dialog">
      <ModalCreate :basic-product-id="basicProductId" @closed="closeCreateModal" />
    </portal>

    <portal v-if="displayUpdateModal" to="app-dialog">
      <ModalUpdate
        :basic-product-id="basicProductId"
        :product-service="productService"
        @closed="closeUpdateModal"
      />
    </portal>

    <portal v-if="displayCreateUpgradeModal" to="app-dialog">
      <ModalCreateUpgrade :product-service="productService" @closed="closeCreateUpgradeModal" />
    </portal>

    <portal v-if="displayUpdateUpgradeModal" to="app-dialog">
      <ModalUpdateUpgrade
        :product-service-upgrade="productServiceUpgrade"
        @closed="closeUpdateUpgradeModal"
      />
    </portal>

    <portal v-if="displayProductServiceDeleteConfirmation" to="app-dialog">
      <BaseDialogDelete
        danger
        :custom-classes="'max-w-md'"
        @closed="displayProductServiceDeleteConfirmation = false"
        @confirmed="doDeleteProductService"
      />
    </portal>

    <portal v-if="displayProductServiceUpgradeDeleteConfirmation" to="app-dialog">
      <BaseDialogDelete
        danger
        :custom-classes="'max-w-md'"
        @closed="displayProductServiceUpgradeDeleteConfirmation = false"
        @confirmed="doDeleteProductServiceUpgrade"
      />
    </portal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ModalCreate from '@/components/ProductService/ModalCreate.vue';
import ModalUpdate from '@/components/ProductService/ModalUpdate.vue';
import ModalCreateUpgrade from '@/components/ProductService/ModalCreateUpgrade.vue';
import ModalUpdateUpgrade from '@/components/ProductService/ModalUpdateUpgrade.vue';
import GridCard from '@/components/ProductService/GridCard.vue';

export default {
  name: 'ProductServicesView',
  components: {
    ModalCreate,
    ModalUpdate,
    ModalCreateUpgrade,
    ModalUpdateUpgrade,
    GridCard,
  },
  props: {
    basicProductId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
    displayCreateModal: false,
    displayUpdateModal: false,
    displayCreateUpgradeModal: false,
    displayUpdateUpgradeModal: false,
    displayProductServiceDeleteConfirmation: false,
    displayProductServiceUpgradeDeleteConfirmation: false,
  }),
  created() {
    this.fetchBasicProductServices();
  },
  computed: {
    ...mapGetters('admin/productServices', ['productServices', 'productService']),
    ...mapGetters('admin/productServiceUpgrades', ['productServiceUpgrade']),
  },
  destroyed() {
    this.setIds([]);
  },
  methods: {
    ...mapActions('admin/productServices', [
      'fetchBasicProductServiceList',
      'deleteProductService',
    ]),
    ...mapActions('admin/productServiceUpgrades', ['deleteProductServiceUpgrade']),
    ...mapMutations('admin/productServices', ['setIds', 'setCurrent']),
    ...mapMutations('admin/productServiceUpgrades', {
      setCurrentProductServiceUpgrade: 'setCurrent',
    }),
    fetchBasicProductServices(params) {
      this.fetching = true;
      const { basicProductId } = this;
      this.fetchBasicProductServiceList({ basicProductId, params })
        .then(() => {
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },
    openCreateModal() {
      this.displayCreateModal = true;
    },
    closeCreateModal() {
      this.displayCreateModal = false;
    },
    openUpdateModal(productServiceUuid) {
      this.setCurrent(productServiceUuid);
      this.displayUpdateModal = true;
    },
    closeUpdateModal() {
      this.displayUpdateModal = false;
      this.setCurrent(null);
    },
    openCreateUpgradeModal(productServiceUuid) {
      this.setCurrent(productServiceUuid);
      this.displayCreateUpgradeModal = true;
    },
    closeCreateUpgradeModal() {
      this.displayCreateUpgradeModal = false;
      this.setCurrent(null);
    },
    openUpdateUpgradeModal(productServiceUpgradeUuid) {
      this.setCurrentProductServiceUpgrade(productServiceUpgradeUuid);
      this.displayUpdateUpgradeModal = true;
    },
    closeUpdateUpgradeModal() {
      this.displayUpdateUpgradeModal = false;
      this.setCurrentProductServiceUpgrade(null);
    },
    confirmProductServiceDeleteAction(productServiceUuid) {
      this.setCurrent(productServiceUuid);
      this.displayProductServiceDeleteConfirmation = true;
    },
    confirmProductServiceUpgradeDeleteAction(productServiceUpgradeUuid) {
      this.setCurrentProductServiceUpgrade(productServiceUpgradeUuid);
      this.displayProductServiceUpgradeDeleteConfirmation = true;
    },
    async doDeleteProductService() {
      if (!this.productService) {
        return;
      }

      try {
        const { uuid: productServiceUuid } = this.productService;
        await this.deleteProductService({ productServiceUuid });
        this.setCurrent(null);
      } catch (e) {
        //
      }
    },
    async doDeleteProductServiceUpgrade() {
      if (!this.productServiceUpgrade) {
        return;
      }

      try {
        const { uuid: productServiceUpgradeUuid } = this.productServiceUpgrade;
        await this.deleteProductServiceUpgrade({ productServiceUpgradeUuid });
        this.setCurrentProductServiceUpgrade(null);
      } catch (e) {
        //
      }
    },
  },
};
</script>
